import { useState, KeyboardEvent, ChangeEvent } from 'react';
import { Label } from '../Label';
import { FormikProps } from 'formik';
import { InputFormik } from '../InputFormik';

interface EditableLabelInputFormikProps<T> {
    id: string;
    context: FormikProps<T>;
    label: string;
    isRequired?: boolean;
    className?: string;
    type?: string;
    placeholder?: string;
    value?: string;
    maxLength?: number;
    isDisabled?: boolean;
    iconSrc?: string;
    iconAlt?: string;
    iconOnClick?: () => void;
    rightAlignErrorMsg?: boolean;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
    onLabelChange?: (newLabel: string) => void;
}
export const EditableLabelInputFormik = <T extends object>({
    id,
    context,
    label,
    isRequired,
    className,
    onLabelChange,
    ...rest
}: EditableLabelInputFormikProps<T>) => {
    const [editableLabel, setEditableLabel] = useState(label);
    const [isEditing, setIsEditing] = useState(false);

    const handleLabelBlur = () => {
        setIsEditing(false);
        onLabelChange?.(editableLabel);
    };

    const handleLabelKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') handleLabelBlur();
        if (e.key === 'Escape') {
            setEditableLabel(label);
            setIsEditing(false);
        }
    };

    return (
        <div>
            <div>
                {isEditing ? (
                    <input
                        className="input-style__label-input paragraph-4"
                        value={editableLabel}
                        onChange={e => setEditableLabel(e.target.value)}
                        onBlur={handleLabelBlur}
                        onKeyDown={handleLabelKeyDown}
                        autoFocus
                    />
                ) : (
                    <div className="input-style__label-container">
                        <Label label={editableLabel} isRequired={isRequired} className="paragraph-4" />
                        <button type="button" onClick={() => setIsEditing(true)} aria-label="Edit label">
                            <img className="input-style__label-icon" src="/svg/pen.svg" alt="Edit label" />
                        </button>
                    </div>
                )}
            </div>
            <InputFormik id={id} context={context} label={undefined} {...rest} />
        </div>
    );
};
